var map = {
	"./logo-event/LogoEvento": 11,
	"./logo-event/LogoEvento.png": 11,
	"./logo/logo-giuliani-white": 12,
	"./logo/logo-giuliani-white.svg": 12,
	"./logo/logo-prex-white": 13,
	"./logo/logo-prex-white.svg": 13,
	"./logo/logo_prex_bianco": 14,
	"./logo/logo_prex_bianco.png": 14,
	"./logo/logo_prex_rosso": 15,
	"./logo/logo_prex_rosso.png": 15,
	"./room/hall_v1": 16,
	"./room/hall_v1.png": 16,
	"./room/live_v1": 17,
	"./room/live_v1.png": 17,
	"./room/room_live_v1": 18,
	"./room/room_live_v1.png": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;